import React from 'react';
import { CheckCircle, X } from 'lucide-react';
import { useCart } from '../../context/CartContext';
import './Toast.css';

const Toast = () => {
  const { toastMessage, showToast } = useCart();

  if (!toastMessage) return null;

  return (
    <div className="toast-notification-banner" role="status" aria-live="polite">
      <div className="toast-inner-content">
        <CheckCircle size={18} className="toast-icon-check" />
        <span className="toast-text-msg">{toastMessage}</span>
        <button
          type="button"
          className="toast-close-btn"
          onClick={() => showToast(null)}
          aria-label="Dismiss message"
        >
          <X size={15} />
        </button>
      </div>
    </div>
  );
};

export default Toast;

